module.exports = __webpack_public_path__ + "media/configurations/P-SX-SX-P-5455a2b7.png";